import axios from 'axios'
import {msg_sucesso,msg_erro} from '../../mixin'

export function getEnums ({commit},payload) {
    
    axios.get (payload.url,  { params: payload.arg})
    .then(res => {
        
        if(res.data){        
            
            if(res.data.data.length == 0){
                this._vm.$toastr('error',"Nenhum registro encontrado");
                commit('pagination',{});
                commit('enums',[]);
            }
            
            let pagination = {
                current_page: res.data.meta.current_page,
                last_page: res.data.meta.last_page,
                next_page_url: res.data.links.next,
                prev_page_url: res.data.links.prev
            };

            commit('pagination',pagination);
            commit('enums',res.data.data);
        }
    }, () =>{        
        
        commit('pagination',{});
        commit('enums',[]);
        this._vm.$toastr('error',"Ocorreu erro na operação, por favor tente novamente.");
    });     
}

export function getData({commit},payload) {
    commit('disableForm', true);

    axios.get('/enum/'+payload)
    .then(res => {        

        
        if(res.data){
            commit('data', res.data.data);
            commit('disableForm', false);            
        }else{
            this._vm.$toastr('error',"Ocorreu erro ao carregar os dados, por favor atualize a página.")
        }
    }, () =>{
        this._vm.$toastr('error',"Ocorreu erro ao carregar os dados, por favor atualize a página.")
    })
}


export function saveData({getters,commit}) {
    
    let data = getters.data;
    let url = '/enum';
    let method = 'post';
    if (data.id && data.id!='') {
        url = "/enum/" + data.id
        method = 'put';
    }
    
    axios({ method, url, data })    
    .then(res => {        

    
        if(res.data && res.data.sucesso){
             commit('data', res.data.data);             
             this._vm.$toastr('success',"Registro gravado com sucesso.")
        }else{

            if(res.data && res.data.error && res.data.error.tag){
                this._vm.$toastr('error',"A tag já está sendo utilizada, por favor informe outra tag.")
            }else{	
                this._vm.$toastr('error',"Ocorreu erro ao carregar os dados, por favor atualize a página.")
            }
        }
    }, () =>{
        this._vm.$toastr('error',"Ocorreu erro ao carregar os dados, por favor atualize a página.")
    })
}